import { render, staticRenderFns } from "./CommentsFormatter.vue?vue&type=template&id=36af52b5&scoped=true"
import script from "./CommentsFormatter.vue?vue&type=script&lang=ts"
export * from "./CommentsFormatter.vue?vue&type=script&lang=ts"
import style0 from "./CommentsFormatter.vue?vue&type=style&index=0&id=36af52b5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af52b5",
  null
  
)

export default component.exports